
























































































import { Vue, Component } from 'vue-property-decorator';

import { Surface, Typography } from '@/components/atoms';
import {
  CampaignStatus,
  CampaignStatistics,
  CampaignSettings,
  CampaignCustomers
} from '@/components/organisms/OfferFreeCoins/DataPresentation';
import Page from '@/componentsV2/molecules/Page/Page.vue';
import { BreadcrumbData } from '@/componentsV2/molecules/Breadcrumbs/Breadcrumbs.vue';

import OfferFreeCoinsService from '@/api/OfferFreeCoinsService';
import AnalyticsService from '@/api/AnalyticsService';

import DateUtils from '@/utils/DateUtils';
import eventBus from '@/utils/eventBus';
import { treatError } from '@/utils';

import { Campaign } from '@/models/marketingCenter/freeCoins';
import ModalOptions from '@/components/Modal/ModalOptions';
import PerformanceUtils from '@/utils/PerformanceUtils';
import { IChartSerie } from '@/models/performance';

@Component({
  components: {
    Surface,
    Typography,
    CampaignStatistics,
    CampaignStatus,
    CampaignSettings,
    CampaignCustomers,
    Page
  }
})
export default class OfferFreeCoinsOffersList extends Vue {
  offerFreeCoinsService: OfferFreeCoinsService = new OfferFreeCoinsService();
  analyticsService: AnalyticsService = new AnalyticsService();

  campaign: Campaign = {} as Campaign;
  loading: boolean = false;
  dateUtils: DateUtils = new DateUtils();

  series: IChartSerie[] = [];

  get breadcrumbs() {
    const breadcrumbList: BreadcrumbData[] = [
      {
        label: 'Campaigns',
        path: '/marketing-center/offer-free-coins'
      }
    ];

    if (this.campaign.createdAt) {
      breadcrumbList.push({
        label: this.dateUtils.getShortFormattedDate(this.campaign.createdAt)
      });
    } else {
      if (!this.loading) {
        breadcrumbList.push({ label: 'Campaign Detail' });
      }
    }

    return breadcrumbList;
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get title() {
    return 'Welcome Coins Campaign';
  }

  get createdAt() {
    if (this.campaign.createdAt) {
      return DateUtils.formatISODate(this.campaign.createdAt);
    }
    return null;
  }

  get coins() {
    return Number(this.campaign.coinsReward) || 0;
  }

  get customerLimit() {
    return this.campaign.customerLimit;
  }

  get visibilityType() {
    return this.campaign.visibilityType;
  }

  get expiration() {
    return this.campaign.dateLimit;
  }

  get status() {
    return this.campaign.status === 'active';
  }

  get customerLimitType() {
    return this.campaign.limitType;
  }

  async getOfferData() {
    const { from = '', to = '' } = this.$route.query;

    try {
      this.loading = true;
      this.$showLoaderWithLocker();
      const { campaign } = this.$route.params;

      const response = await this.offerFreeCoinsService.listOfferFreeCoins(
        undefined,
        {
          params: {
            searchableFields: 'firstcoin_campaign.id',
            search: campaign,
            initialDateFreecoins: from,
            stoppedDateFreecoins: to
          }
        }
      );

      if (response.data.items.length) {
        const campaign = response.data.items[0];

        this.campaign = campaign;
        this.series = PerformanceUtils.normalizedChartSeries({
          ...campaign.chart,
          datasets: [{ ...campaign.chart.datasets, label: 'Customers' }]
        });
      } else {
        this.$router.push('/marketing-center/offer-free-coins');
      }
    } catch {
      this.$router.push('/marketing-center/offer-free-coins');
    } finally {
      this.loading = false;
      this.$hideLoader();
    }
  }

  async updateActiveCampaign({ id, status }: { id: string; status: boolean }) {
    try {
      this.$showLoaderWithLocker();

      const newStatus = status ? 'inactive' : 'active';

      const response = await this.offerFreeCoinsService.updateOfferFreeCoin(
        id,
        {
          allowRepeatingCustomers: this.campaign.allowRepeatingCustomers,
          limitType: this.campaign.limitType,
          visibilityType: this.campaign.visibilityType,
          customerLimit: this.campaign.customerLimit,
          dateLimit: this.campaign.dateLimit || undefined,
          status: newStatus
        }
      );

      if (response.status !== 200) return;

      this.campaign = {
        ...this.campaign,
        status: newStatus
      };

      const statusLabel = status ? 'deactivated' : 'activated';

      this.$notification(`Campaign successfully ${statusLabel}`);

      this.$analytics({
        eventCategory:
          'Free Coins Campaign Detail | Active/Inactive switch component',
        eventAction: 'click',
        eventLabel: `${statusLabel.charAt(0).toUpperCase() +
          statusLabel.slice(1)} campaign`
      });
    } catch (e) {
      treatError(e);
    } finally {
      this.$hideLoader();
    }
  }

  back() {
    this.$router.push('/marketing-center/offer-free-coins');
  }

  updateCampaign(campaign: Campaign) {
    this.campaign = campaign;
  }

  mounted() {
    this.getOfferData();

    eventBus.$on('changeFreeCoinCampaignStatus', this.updateActiveCampaign);
    eventBus.$on('updateFreeCoinDetailCampaign', this.updateCampaign);
  }

  beforeDestroy() {
    eventBus.$off('changeFreeCoinCampaignStatus', this.updateActiveCampaign);
    eventBus.$off('updateFreeCoinDetailCampaign', this.updateCampaign);
  }

  onShare() {
    eventBus.$emit(
      'openSubModal',
      new ModalOptions(
        ``,
        ``,
        'none',
        true,
        ``,
        ``,
        ``,
        false,
        'campaignShareModal',
        false,
        true,
        true,
        true,
        true
      ),
      { isDetail: true, modalViewEvent: 'Free Coins/Share' }
    );

    this.$analytics({
      eventCategory: 'Free Coins Campaign Detail | Share campaign button',
      eventAction: 'click',
      eventLabel: 'Clicked on Share campaign button'
    });
  }
}
